import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../utils/translator.helper';
import {
  ApplicationControlStartRuleItem,
  ApplicationControlStartRuleItemFormValue,
} from '@nirvana/shared/dtos/types/policies/common';

// validate duplicates
export function validateDuplicates(
  ruleItem: ApplicationControlStartRuleItemFormValue,
  rulesInGrid: ApplicationControlStartRuleItem[]
): ValidationResult {
  const hasDuplicates = rulesInGrid.some(
    (ruleInGrid: ApplicationControlStartRuleItem) => ruleInGrid.name === ruleItem.name
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
